import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { Loader } from '../loader/loader';

@Component({
    selector: 'qpx-loading-state',
    imports: [Loader],
    template: `
        <qpx-loader
            [ariaLabel]="ariaLabel()"
            [ariaLabelledBy]="ariaLabelledBy()"
        />
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        class: 'qpx-loading-state',
    },
})
export class LoadingState {
    // --- Inputs ---
    public readonly ariaLabel = input('');
    public readonly ariaLabelledBy = input('');
}
